<template>
  <div class="registerFloat alone-style">
    <dialogTem :visible.sync="showloginfloat" :types="'signup'" :diaWidth="'800px'"
    :diaTitle="$t('newHome.signup')" @handleCloseDialog="()=>setshowloginfloat(false)">
      <!-- 注册内容 -->
      <div class="login-body" v-if="!isLogin">
        <div class="box-left">
          <el-form
            class="form-horizontal newform"
            ref="ruleForm"
            label-width="100px"
            :model="user"
            :rules="rules"
            label-position="top"
          >
          <el-form-item prop="username">
            <div :class="{'signUpStyle':changeSyle.regsStatus,signupComlabel:true}">
              <span class="tips">*</span>
              {{$t('header.user')}}
            </div>
            <el-input type="text" v-model="user.username" 
            autocomplete="off" :max="12" :disabled="isReady"
            :placeholder="changeSyle.regsStatus ? $t('register.userPlace') : '' " 
            @keyup.enter.native="submitForm('ruleForm')"  
            @focus="handleFocus(user.username,'regsStatus')" 
            @blur="handleBlur(user.username,'regsStatus')" class="icon_username">
            </el-input>
          </el-form-item>

          <el-form-item prop="password">
            <div :class="{'signUpStyle':changeSyle.regsStatus01,signupComlabel:true}">
              <span class="tips">*</span>
              {{$t('header.password')}}
            </div>
            <el-input :type="flag ? 'password':'text'" v-model="user.password" autocomplete="off" :max="12"
            :placeholder="changeSyle.regsStatus01 ? $t('register.userPlace') : '' " 
            @keyup.enter="submitForm('ruleForm')" :disabled="isReady"
            @focus="handleFocus(user.password,'regsStatus01')" 
            @blur="handleBlur(user.password,'regsStatus01')" class="icon_password">
            <i slot="suffix" :class="flag ? 'close_eye':'el-icon-view'" autocomplete="auto" @click="flag=!flag" />
            </el-input>
          </el-form-item>

          <el-form-item prop="repeatPassword">
            <div :class="{'signUpStyle':changeSyle.regsStatus02,signupComlabel:true}">
              <span class="tips">*</span>
              {{$t('register.ConfirmPassword')}}
            </div>
            <el-input :type="repertFlag ? 'password':'text'" v-model="user.repeatPassword" autocomplete="off" 
            :placeholder="changeSyle.regsStatus02 ? $t('register.passwordPlace') : '' "
            @keyup.enter.native="submitForm('ruleForm')" :disabled="isReady"
            @focus="handleFocus(user.repeatPassword,'regsStatus02')" 
            @blur="handleBlur(user.repeatPassword,'regsStatus02')" class="icon_password">
            <i slot="suffix" :class="repertFlag ? 'close_eye':'el-icon-view'" autocomplete="auto" @click="repertFlag=!repertFlag" />
            </el-input>
          </el-form-item>
          
            <!-- 自定义注册项 -->
          <template v-if="RegisterList && RegisterList.length >0">
            <el-form-item v-for="item in RegisterList" :key="item.id" :prop="item.requireSwitch == 0 ? '' : item.typeName" :class="hasSendPhoneCode == '1' ?  item.typeName : ''">
              <div :class="{'signUpStyle':changeSyle[item.typeName],signupComlabel:true}"> 
                <span class="tips" v-show="item.requireSwitch != 0">*</span>
                {{$t('register')[item.typeName]}}
              </div>
              <el-input
                :maxlength="item.lengthMax"
                :minlength="item.lengthMin"
                type="text"
                v-model="user[item.typeName]"
                autocomplete="off"
                :class="hasSendPhoneCode == '1' ?  item.typeName : ''"
                :disabled="item.typeName == 'phone' ? sending || isReady : isReady"
                :placeholder="changeSyle[item.typeName] ? $t('verificationRegister')[item.typeName] : '' "
                @keyup.enter.native="submitForm('ruleForm')"
                @focus="handleFocus(user[item.typeName],item.typeName)" 
                @blur="handleBlur(user[item.typeName],item.typeName)"
                >
                <!-- :placeholder="$t('register')[item.typeName] -->
                <!-- <span slot="prefix" >+91</span> -->
                <!-- <template slot="append">请输入手机号</template> -->
                <span v-if="hasSendPhoneCode == '1' && item.typeName == 'phone'" slot="prefix" >+91</span>
                <template v-if="hasSendPhoneCode == '1' && item.typeName == 'phone'" slot="suffix" :class="{'disabled':sending}">
                  <el-button round @click.native="sendCode" :disabled="sending">{{$t(sendingTip)}}</el-button>
                </template>
              </el-input>
            </el-form-item>
          </template>
          
          <el-form-item>
            <div :class="{'signUpStyle':changeSyle.regsStatus09,signupComlabel:true}">
              {{$t('register.agent')}}</div>
            <el-input type="text" v-model="user.agentCode" autocomplete="off" :disabled="isReady || Boolean(this.$Cookies.get('agentCode'))"
            :placeholder="changeSyle.regsStatus09 ? $t('register.agent') : '' " 
            @keyup.enter.native="submitForm('ruleForm')" class="icon_referral"
            @focus="handleFocus(user.agentCode,'regsStatus09')" 
            @blur="handleBlur(user.agentCode,'regsStatus09')"
            >
            </el-input>
          </el-form-item>

          <el-form-item prop="verificationCode">
            <div :class="{'signUpStyle':changeSyle.regsStatus10,signupComlabel:true}">
              <span class="tips">*</span>
                {{ hasSendPhoneCode == '1' ? $t('register.phonecodePlace') : $t('header.verification')}}
              </div>
            <el-input
              type="text"
              v-model="user.verificationCode"
              autocomplete="off" class="icon_vercode"
              :placeholder="changeSyle.regsStatus10 ? $t('register.verificationPlace') : '' " 
              @keyup.enter.native="submitForm('ruleForm')"
              @focus="handleFocus(user.verificationCode,'regsStatus10')" 
              @blur="handleBlur(user.verificationCode,'regsStatus10')"
              :disabled="isReady"
            >
              <template slot="suffix" v-if="hasSendPhoneCode != '1'" >
                <img :src="user.securityCodeSrc" @click="!isReady && getVifyCode()" style="margin-top:6px" />
              </template>
            </el-input>
          </el-form-item>
        </el-form>
        <div class="flex-button">
          <div class="RememberMe">
            <el-checkbox v-model="checked">{{$t('register.agree')}}</el-checkbox>
            <router-link to="/helpCenter/startUse?id=3&index=1" style="color:#fff;border-bottom:1px solid #fff">
              <span @click="setshowloginfloat(false)">{{$t('register.Terms')}}</span>
            </router-link>
          </div>
          <div class="btn-group">
            <el-button :loading="isReady" type="primary" @click="submitForm('ruleForm')" @keyup.enter.native="submitForm('ruleForm')" class="_reg_now">{{$t('header.signup')}}</el-button>
          </div>
        </div>
        <div class="Returnsignin" @click="gologin">{{$t('dialog.goLogin')}}</div>
      </div>
    </div>

      <!--注册成功 -->
      <div class="reg-success" v-else>
        <p class="_title">{{ $t('createdDislaog.diaTitle') }}!</p>
        <div class="succ-image"><img src="../img/success_bg.png" alt width="100%" height="auto"/></div>
        <p class="despoit_btn" @click="handleDespoit">{{ $t('mine.capital.deposit') }}</p>
      </div>
    </dialogTem>
  </div>
</template>

<script>
import dialogTem from '../dialogTem.vue'
import languages from '../languages.vue'
import { mapState, mapActions, mapMutations } from "vuex";
import { common , commonApi , INcheck  } from "@/common/index";
import { validateRegister } from '../../utils/validate'
  import { getVerifyParam} from '@/common/api/bindAuthenticate.js'
export default {
  components:{ languages,dialogTem },
  data() {
    return {      
      timer: null,
      sendingTip:'register.sendingTip',
      sending: false,
      flag:true,
      repertFlag:true,
      RegisterList:'',
      user: {
        username: "",
        password: "",
        repeatPassword: "",
        phone: "",
        agentCode: "",
        domain: "",
        securityCodeSrc: "",
        timestamp: "",
        verificationCode: "",
        realName:'',
        qq:'',
        wechat:'',
        email:'',
        withdrawPassword:'',
      },
      checked: true,
      isReady: false,
      rules:validateRegister(this),
      changeSyle:{
        regsStatus:false,
        regsStatus01:false,
        regsStatus02:false,
        realName:false,
        qq:false,
        wechat:false,
        email:false,
        phone:false,
        withdrawPassword:false,
        regsStatus09:false,
        regsStatus10:false
      },
      captchaId:'',
      geetestResult:null,
    };
  },
  computed: {
    ...mapState({
      UUID: (state) => state.UUID,
      isLogin: (state) => state.isLogin,
      showloginfloat: (state) => state.showloginfloat,
      hasSendPhoneCode: state => state.linkList.hasSendPhoneCode,
    }),
    // 手机号
    Register_phoneNumber(){ 
      if(this.RegisterList.length>0){
        return  this.RegisterList.filter(item => item.typeName == 'phone')
      }
    },
    // 真实姓名
    Register_realName(){
      if(this.RegisterList.length>0){
        return  this.RegisterList.filter(item => item.typeName == 'realName')
      }
    },
    // qq
    Register_qq(){
      if(this.RegisterList.length>0){
        return  this.RegisterList.filter(item => item.typeName == 'qq')
      }
    },
    // 微信
    Register_wechat(){
      if(this.RegisterList.length>0){
        return  this.RegisterList.filter(item => item.typeName == 'wechat')
      }
    },
    // 电子邮箱
    Register_email(){
      if(this.RegisterList.length>0){
        return  this.RegisterList.filter(item => item.typeName == 'email')
      }
    },
    // 提款密码
    Register_withdrawPassword(){
      if(this.RegisterList.length>0){
        return  this.RegisterList.filter(item => item.typeName == 'withdrawPassword')
      }
    }
  },
  watch: {
    showloginfloat(v) {
      if (v) {
        this.user.agentCode = this.$Cookies.get('agentCode') || ''
        if(this.user.agentCode) this.changeSyle.regsStatus09 = true
      }
    },
  },
  methods: {
    getGTConfig (){
           getVerifyParam({ type:'pc', appType: 'pc' }).then(([data, err, res]) => {
                //接口地址是你后端给你的地址  里面的参数是initGeetest需要的参数
                if (res.data.code === 200) {
                    this.captchaId = data.captchaId;
                }
            })
        },
        onInitGeetest(fnCallBack) {
             var _that =this;

            initGeetest4({
                    captchaId: _that.captchaId,
                    product: 'bind',
                    language: "eng",
                    riskType: 'slide',
                },function (captcha) {
                // captcha为验证码实例
                captcha.onReady(function(){
                    }).onSuccess(function(){
                        _that.geetestResult = captcha.getValidate();
                        if (! _that.geetestResult) {
                            return alert('Complete verification');
                        }
                        _that.geetestResult.captcha_id = _that.captchaId
                        fnCallBack();
                    }).onError(function(){
                        //your code
                    })
                    captcha.showCaptcha(); //调起极验
                    // document.getElementById('geetest').addEventListener('click', function () {
                    //   captcha.showCaptcha(); 
                    // })
                
                    
            });

        },
    ...mapMutations(["setshowloginfloat", "setshowloginfloat2"]),
    ...mapActions(["checkLogin", "IS_LOGIN_FOCUS", "Login"]),
      handleFocus(ele,val){
      if(!ele){ this.changeSyle[val] = !this.changeSyle[val]}
    },
    handleBlur(ele,val){
      if(!ele){ this.changeSyle[val] = !this.changeSyle[val] }
    },
    gologin() {
      this.setshowloginfloat(false);
      this.setshowloginfloat2(true);
    },
    handleDespoit(){
      this.$router.push({path:'/mine/deposit'})
      this.setshowloginfloat(false);
    },
    _notify(message,title = this.$t('notify.warning'),type = 'warning'){ this.$notify({ title,message,type })},
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.isReady = true;
          let params = {
            username: this.user.username,
            password: this.user.password,
            repeatPassword: this.user.repeatPassword,
            phone: this.user.phone,
            agentCode: this.user.agentCode,
            timestamp: this.user.timestamp,
            regDomain: this.user.domain,
            vrifyCode: this.user.verificationCode,
            realName:this.user.realName,
            qq:this.user.qq,
            wechat:this.user.wechat,
            email:this.user.email,
            withdrawPassword:this.user.withdrawPassword,
            regType:this.hasSendPhoneCode == 1?'3':''
          };
          let isOK = this.checkForm();
          if (isOK) {
            this.$api.post(this.$urls.USER.REGISTER,params,(resp) => {
              if (resp.data.code === 200) {
                this.$Cookies.remove('agentCode')
                // this.setshowloginfloat(false);
                this.$refs[formName].resetFields();
                this.isReady = false;
                let UUID = resp.data.data;
                this.$Cookies.set("UUID", UUID);
                this.Login(UUID);
                common.logedUserInfo();
                // clearObject(this.user)
                for (let key in this.user) this.user[key] = ''
                for (let key in this.changeSyle) this.changeSyle[key] = false
              }
              if (resp.data.code !== 200) {
                this.isReady = false;
                this.getVifyCode();
                this._notify(resp.data.msg)
              }
            },(err) => { this.isReady = false;});
          } else { this.isReady = false; }
        } else {
          this._notify(this.$t('login.finishContent'))
        }
      });
    },
    checkForm() {
      let isOK = true;
      let msg = INcheck.INcheckRealname(this.user.username);
      let pwd = INcheck.checkRegisterPassword(this.user.password);
      let phone = INcheck.checkPhone(this.user.phone);
      let repeatMsg = INcheck.checkConfirm(
        this.user.password,
        this.user.repeatPassword
      );
      if (msg) { //检验账号
        this._notify(this.$t(msg))
        return isOK = false;
      }
      if (pwd) {  //校验密码
        this._notify(this.$t(pwd))
        return isOK = false;
      }
     if(this.Register_phoneNumber?this.Register_phoneNumber.length>0?true:false:false){
        if(this.Register_phoneNumber[0].requireSwitch == '0' && this.user.phone){
          if(!/^\d{10}$/.test(this.user.phone)){
            this._notify(this.$t('form.checkPhone2'))
            return isOK = false;
          }
        }
      }
      // 邮箱
      if(this.Register_email?this.Register_email.length>0?true:false:false){
        if(this.Register_email[0].requireSwitch == '0' && this.user.email){
          if(!/^[A-Za-z0-9]+([_\.][A-Za-z0-9]+)*@([A-Za-z0-9\-]+\.)+[A-Za-z]{2,6}$/.test(this.user.email)){
            this._notify(this.$t('register.emailRulse3'))
            return isOK = false;
          }
        }
      }
      // 密码确认
      if (repeatMsg) {
        this._notify(this.$t(repeatMsg))
        return isOK = false;
      }
      // 协议
      if (!this.checked) {
        this._notify(this.$t('register.pleaseRead'))
        return isOK = false;
      }
      if (this.user.verificationCode === "") {
        this._notify(this.$t('header.checkVrifyCode'))
        return isOK = false;
      }
      return isOK;
    },

    // 获取验证码
    getVifyCode() {
      this.vrifyCode = "";
      let randomStr = common.randomRange(16);
      let timer = Math.floor(Date.now() / 1000);
      this.user.securityCodeSrc =
        this.$urls.USER.REGISTERCODE + `?timestamp=${timer}` + randomStr;
      this.user.timestamp = timer + randomStr;
    },
    // 获取自定义注册项
    getRegisterList () {
      commonApi.HOMEBEFORE.getRegisterList().then(data => {
        this.RegisterList = data
      }).catch(err => { console.log(err) })
    },
    // 获取手机验证码
    sendCode() {
      if (!INcheck.checkPhone(this.user.phone)) {
        this.onInitGeetest(()=>{
          commonApi.CONFIRM.sendVerify({
            phoneNum: this.user.phone,
            type: 'pc',
            appType: 'pc',
            lotNumber: this.geetestResult.lot_number,
            captchaOutput: this.geetestResult.captcha_output,
            passToken: this.geetestResult.pass_token,
            genTime: this.geetestResult.gen_time
          }).then((data) => {
            this.sending = true;
            this.countDown(60);
            this._notify(this.$t('register.Sentsuccessfully'),this.$t('notify.success'),'success')
          }).catch((err) => {
            this.sending = false;
            this._notify(err)
          })
        })
      }else{ this._notify(this.$t(INcheck.checkPhone(this.user.phone)))}
    },
    // 倒計時
    countDown(Countdown) {
      this.timer = setInterval(() => {
        this.sendingTip = Countdown + 's'
        Countdown--;
        if (Countdown < 0) {
          clearInterval(this.timer);
          this.sending = false;
          this.sendingTip = this.$t('register.sendingTip')
        }
      }, 1000);
    },
  },
  mounted() {
    this.getGTConfig();
    this.getVifyCode();
    this.getRegisterList();
  },
};
</script>

<style scoped lang="scss">
@import './index.scss';
.registerFloat {
  .login-body { 
    padding:8px 22px 70px;
    .box-left{
      .el-form{
        display:flex;
        justify-content: space-between;
        flex-wrap: wrap;
        .login{
          color: #fff;
          text-align: center;
          cursor: pointer;
          padding-bottom: 15px;
        }
        .el-form-item {
          width:48.6%;
          margin-bottom:10px!important;
        }
      }
      ._reg_now{ width:348px;margin-top:0;}
      .flex-button{
        display:flex;
        justify-content: space-between;
        align-items: center;
      }
    }
    .Returnsignin{ 
      color:#fff;
      text-align: center;
      margin-top:50px;
      cursor: pointer;
    }
  }
  .reg-success{  // 注册成功
    padding-bottom:80px;
    text-align: center;
    ._title{
      font-family: Roboto-Black;
      font-size: 30px;
      color: #ffffff;
      font-weight: 800;
      margin-bottom:28px;
    }
    .succ-image{ width:91px;height:92px;margin:0 auto;}
    .despoit_btn{
      width: 336px;
      margin:50px auto 0;
      height: 50px;
      line-height: 50px;
      text-align: center;
      background-image: linear-gradient(90deg,#80fbb4 0%,#c3fd7c 100%);
      border-radius: 4px;
      font-weight: bold;
      cursor: pointer;
      font-family: Roboto-Black;
      font-size: 16px;
      color: #222;
    }
  }
}
</style>

<style lang="scss">
.registerFloat{
  .el-input__inner {
    &::placeholder {
      color:#b1b1b1;
      font-size:13px;
    }

    &::-webkit-input-placeholder {
        /* WebKit browsers 适配谷歌 */
      color: #b1b1b1;
    }

    &:-moz-placeholder {
        /* Mozilla Firefox 4 to 18 适配火狐 */
      color: #b1b1b1;
    }

    &::-moz-placeholder {
        /* Mozilla Firefox 19+ 适配火狐 */
      color: #b1b1b1;
    }

    &:-ms-input-placeholder {
        /* Internet Explorer 10+  适配ie*/
      color: #b1b1b1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/build901/components/common/register/register.vue